import reverse from 'lodash/reverse';
import sortBy from 'lodash/sortBy';
import { storableError } from '../../util/errors';
import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { keyedSubmission } from '../ListingPage/submissionKeys';
import { createCheckoutSession, createNewListing, dockCreateCredentials, dockGetCredentials, dockRevokeCredential, saveWalletPagePayments, saveConsent, updateOtherUsers, uploadFileToBlob, getCredentialVaultDocNames, getPersonaFieldValues, shareCredential, reportCredentialCheckFailed, fetchCandidateIntegrityStatus as fetchCandidateIntegrityStatusApi, markIntegrityCheckVerificationCompleted as markIntegrityCheckVerificationCompletedApi, fetchWalletDocumentStates as fetchWalletDocumentStatesApi } from '../../util/api';
import { rsaHybridDecrypt } from '../../util/rsa-crypto';
import { verifyAndExtractSignature } from '../../util/ed25519-crypto';
import { credentialTrustStateOf } from '../../util/credentialTrust';
import { CREDENTIAL_CHECK_FAILED, withTrustStates } from './walletCredentialTrust';
import { fetchCurrentUser, fetchUserPersonaRecords, loadCompanyCredentialDetails } from '../../ducks/user.duck';
import { userTypeOf } from '../../util/userType';
import { teamRoleOf } from '../../util/teamRole';
import { withOwnPrivateData } from '../../util/withOwnPrivateData';
import { walletRecordOf, separateWalletRecords } from '../../util/walletRecords';
import { SCREENING_SHARED_FIELDS } from '../../util/screeningCredentialTypes';

const sortedTransactions = txs =>
  reverse(
    sortBy(txs, tx => {
      return tx.attributes ? tx.attributes.lastTransitionedAt : null;
    })
  );

// ================ Action types ================ //

export const FETCH_ORDERS_OR_SALES_REQUEST = 'app/WalletPage/FETCH_ORDERS_OR_SALES_REQUEST';
export const FETCH_ORDERS_OR_SALES_SUCCESS = 'app/WalletPage/FETCH_ORDERS_OR_SALES_SUCCESS';
export const FETCH_ORDERS_OR_SALES_ERROR = 'app/WalletPage/FETCH_ORDERS_OR_SALES_ERROR';

export const CREATE_CHECKOUT_SESSION_REQUEST = 'app/WalletPage/CREATE_CHECKOUT_SESSION_REQUEST';
export const CREATE_CHECKOUT_SESSION_SUCCESS = 'app/WalletPage/CREATE_CHECKOUT_SESSION_SUCCESS';
export const CREATE_CHECKOUT_SESSION_ERROR = 'app/WalletPage/CREATE_CHECKOUT_SESSION_ERROR';

export const UPDATE_OTHER_USER_REQUEST = 'app/WalletPage/UPDATE_OTHER_USER_REQUEST';
export const UPDATE_OTHER_USER_SUCCESS = 'app/WalletPage/UPDATE_OTHER_USER_SUCCESS';
export const UPDATE_OTHER_USER_ERROR = 'app/WalletPage/UPDATE_OTHER_USER_ERROR';

export const BLOB_FILE_UPLOAD_IMAGE_REQUEST = 'app/WalletPage/BLOB_FILE_UPLOAD_IMAGE_REQUEST';
export const BLOB_FILE_UPLOAD_IMAGE_SUCCESS = 'app/WalletPage/BLOB_FILE_UPLOAD_IMAGE_SUCCESS';
export const BLOB_FILE_UPLOAD_IMAGE_ERROR = 'app/WalletPage/BLOB_FILE_UPLOAD_IMAGE_ERROR';

export const CREATE_CREDENTIALS_REQUEST = 'app/WalletPage/CREATE_CREDENTIALS_REQUEST';
export const CREATE_CREDENTIALS_SUCCESS = 'app/WalletPage/CREATE_CREDENTIALS_SUCCESS';
export const CREATE_CREDENTIALS_ERROR = 'app/WalletPage/CREATE_CREDENTIALS_ERROR';

export const GET_CREDENTIALS_REQUEST = 'app/WalletPage/GET_CREDENTIALS_REQUEST';
export const GET_CREDENTIALS_SUCCESS = 'app/WalletPage/GET_CREDENTIALS_SUCCESS';
export const GET_CREDENTIALS_ERROR = 'app/WalletPage/GET_CREDENTIALS_ERROR';

export const UPDATE_USER_DID_REQUEST = 'app/WalletPage/UPDATE_USER_DID_REQUEST';
export const UPDATE_USER_DID_SUCCESS = 'app/WalletPage/UPDATE_USER_DID_SUCCESS';
export const UPDATE_USER_DID_ERROR = 'app/WalletPage/UPDATE_USER_DID_ERROR';

export const FETCH_PROFILE_LISTING_REQUEST = 'app/WalletPage/FETCH_PROFILE_LISTING_REQUEST';
export const FETCH_PROFILE_LISTING_SUCCESS = 'app/WalletPage/FETCH_PROFILE_LISTING_SUCCESS';
export const FETCH_PROFILE_LISTING_ERROR = 'app/WalletPage/FETCH_PROFILE_LISTING_ERROR';

export const UPDATE_LISTING_REQUEST = 'app/WalletPage/UPDATE_LISTING_REQUEST';
export const UPDATE_LISTING_SUCCESS = 'app/WalletPage/UPDATE_LISTING_SUCCESS';
export const UPDATE_LISTING_ERROR = 'app/WalletPage/UPDATE_LISTING_ERROR';

export const SAVE_PAYMENT_SESSION_ID_REQUEST = 'app/WalletPage/SAVE_PAYMENT_SESSION_ID_REQUEST';
export const SAVE_PAYMENT_SESSION_ID_SUCCESS = 'app/WalletPage/SAVE_PAYMENT_SESSION_ID_SUCCESS';
export const SAVE_PAYMENT_SESSION_ID_ERROR = 'app/WalletPage/SAVE_PAYMENT_SESSION_ID_ERROR';

export const REVOKE_CREDENTIAL_REQUEST = 'app/WalletPage/REVOKE_CREDENTIAL_REQUEST';
export const REVOKE_CREDENTIAL_SUCCESS = 'app/WalletPage/REVOKE_CREDENTIAL_SUCCESS';
export const REVOKE_CREDENTIAL_ERROR = 'app/WalletPage/REVOKE_CREDENTIAL_ERROR';

export const SAVE_CONSENT_REQUEST = 'app/WalletPage/SAVE_CONSENT_REQUEST';
export const SAVE_CONSENT_SUCCESS = 'app/WalletPage/SAVE_CONSENT_SUCCESS';
export const SAVE_CONSENT_ERROR = 'app/WalletPage/SAVE_CONSENT_ERROR';

export const FETCH_CONSENT_REQUEST = 'app/WalletPage/FETCH_CONSENT_REQUEST';
export const FETCH_CONSENT_SUCCESS = 'app/WalletPage/FETCH_CONSENT_SUCCESS';
export const FETCH_CONSENT_ERROR = 'app/WalletPage/FETCH_CONSENT_ERROR';

export const FETCH_VAULT_DOC_NAMES_REQUEST = 'app/WalletPage/FETCH_VAULT_DOC_NAMES_REQUEST';
export const FETCH_VAULT_DOC_NAMES_SUCCESS = 'app/WalletPage/FETCH_VAULT_DOC_NAMES_SUCCESS';
export const FETCH_VAULT_DOC_NAMES_ERROR = 'app/WalletPage/FETCH_VAULT_DOC_NAMES_ERROR';

export const FETCH_CANDIDATE_INTEGRITY_STATUS_REQUEST = 'app/WalletPage/FETCH_CANDIDATE_INTEGRITY_STATUS_REQUEST';
export const FETCH_CANDIDATE_INTEGRITY_STATUS_SUCCESS = 'app/WalletPage/FETCH_CANDIDATE_INTEGRITY_STATUS_SUCCESS';
export const FETCH_CANDIDATE_INTEGRITY_STATUS_ERROR = 'app/WalletPage/FETCH_CANDIDATE_INTEGRITY_STATUS_ERROR';

export const MARK_INTEGRITY_CHECK_VERIFICATION_COMPLETED = 'app/WalletPage/MARK_INTEGRITY_CHECK_VERIFICATION_COMPLETED';

export const FETCH_WALLET_DOCUMENT_STATES_REQUEST = 'app/WalletPage/FETCH_WALLET_DOCUMENT_STATES_REQUEST';
export const FETCH_WALLET_DOCUMENT_STATES_SUCCESS = 'app/WalletPage/FETCH_WALLET_DOCUMENT_STATES_SUCCESS';
export const FETCH_WALLET_DOCUMENT_STATES_ERROR = 'app/WalletPage/FETCH_WALLET_DOCUMENT_STATES_ERROR';

export const FETCH_VAULT_DOC_DETAILS_REQUEST = 'app/WalletPage/FETCH_VAULT_DOC_DETAILS_REQUEST';
export const FETCH_VAULT_DOC_DETAILS_SUCCESS = 'app/WalletPage/FETCH_VAULT_DOC_DETAILS_SUCCESS';
export const FETCH_VAULT_DOC_DETAILS_ERROR = 'app/WalletPage/FETCH_VAULT_DOC_DETAILS_ERROR';
export const FETCH_VAULT_DOC_DETAILS_UNTRUSTED = 'app/WalletPage/FETCH_VAULT_DOC_DETAILS_UNTRUSTED';


// ================ Reducer ================ //

const entityRefs = entities =>
  entities.map(entity => ({
    id: entity.id,
    type: entity.type,
  }));

const initialState = {
  fetchInProgress: false,
  fetchOrdersOrSalesError: null,
  pagination: null,
  transactionRefs: [],
  users: [],
  pendingUsers: [],
  createCheckoutSessionInProgress: false,
  createCheckoutSessionError: null,
  typeOfCheckoutSession: null,
  getCredentialsError: null,
  createCredentialsError: null,
  // New fields for multiple credentials
  fetchingCredentials: false,
  credentials: [],
  credentialsFetched: 0,
  failedCredentials: [],
  submitInProgress: false,
  updateUserDIDInProgress: false,
  updateUserDIDError: null,
  // Profile listing
  profileListing: null,
  fetchProfileListingInProgress: false,
  fetchProfileListingError: null,
  // Update listing
  updateListingInProgress: false,
  updateListingError: null,
  savingPaymentSuccess: false,
  savingPaymentError: null,
  savingPayment: false,
  // Revoke credential
  revokeCredentialInProgress: false,
  revokeCredentialError: null,
  // Save consent
  savingConsent: false,
  savingConsentSuccess: false,
  savingConsentError: null,
  // Fetch consent
  fetchingConsent: false,
  existingConsent: null,
  fetchConsentError: null,
  // Credential vault
  fetchingVaultDocNames: false,
  vaultDocNames: [],
  fetchVaultDocNamesError: null,
  fetchingVaultDocDetails: false,
  vaultDocDetails: null,
  fetchVaultDocDetailsError: null,
  // Why a vault document's details are not shown: being re-checked, no longer verified, or its
  // response failed the browser's signature check.
  vaultDocDetailsTrust: null,
  // Candidate integrity check status
  fetchingCandidateIntegrityStatus: false,
  candidateHasIntegrityCheck: false,
  // Whether the category on the candidate's EAD card was read and matched their picked category
  candidateEadCategoryConfirmed: false,
  fetchCandidateIntegrityStatusError: null,
  // What each Wallet document needs before it can be verified, as the server decided it
  // ({ [itemId]: { state, reason? } }); null until loaded, and again when it could not be loaded.
  fetchingWalletDocumentStates: false,
  walletDocumentStates: null,
  walletDocumentStatesError: null,
  // Verifications from companies' checks that are this owner's to add to their Wallet.
  walletOwnerVerifications: [],
};

export default function userManagementPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_ORDERS_OR_SALES_REQUEST:
      return { ...state, fetchInProgress: true, fetchOrdersOrSalesError: null };
    case FETCH_ORDERS_OR_SALES_SUCCESS: {
      const transactions = sortedTransactions(payload.data.data);
      return {
        ...state,
        fetchInProgress: false,
        transactionRefs: entityRefs(transactions),
        pagination: payload.data.meta,
      };
    }
    case FETCH_ORDERS_OR_SALES_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, fetchInProgress: false, fetchOrdersOrSalesError: payload };

    case FETCH_WALLET_DOCUMENT_STATES_REQUEST:
      return { ...state, fetchingWalletDocumentStates: true, walletDocumentStatesError: null };
    case FETCH_WALLET_DOCUMENT_STATES_SUCCESS:
      return {
        ...state,
        fetchingWalletDocumentStates: false,
        walletDocumentStates: payload,
        walletOwnerVerifications: Array.isArray(action.ownerVerifications) ? action.ownerVerifications : [],
      };
    case FETCH_WALLET_DOCUMENT_STATES_ERROR:
      // Nothing is guessed in place of an answer that could not be read.
      return {
        ...state,
        fetchingWalletDocumentStates: false,
        walletDocumentStates: null,
        walletOwnerVerifications: [],
        walletDocumentStatesError: payload,
      };

    case CREATE_CHECKOUT_SESSION_REQUEST:
      return { ...state, createCheckoutSessionInProgress: true, createCheckoutSessionError: null, typeOfCheckoutSession: null };
    case CREATE_CHECKOUT_SESSION_SUCCESS: {
      const { url } = payload;
      window.location.href = url; // Redirect to Stripe checkout
      return {
        ...state,
        createCheckoutSessionInProgress: false,
        createCheckoutSessionError: null,
        typeOfCheckoutSession: payload.type || 'default',
      };
    }
    case CREATE_CHECKOUT_SESSION_ERROR:
      console.error(payload); // eslint-disable-line
      return { ...state, createCheckoutSessionInProgress: false, createCheckoutSessionError: payload };
    
    case UPDATE_OTHER_USER_REQUEST:
      return {
        ...state,
      };
    case UPDATE_OTHER_USER_SUCCESS:
      return {
        ...state,
        updated: true,
      };
    case UPDATE_OTHER_USER_ERROR:
      return {
        ...state,
      };  

    case BLOB_FILE_UPLOAD_IMAGE_REQUEST:
      return {
        ...state,
        blobFile: { ...payload.params },
        blobFileUploadInProgress: true,
        blobFileUploadError: null,
      };
    case BLOB_FILE_UPLOAD_IMAGE_SUCCESS: {
      const { id, blobUrl } = payload;
      const { file } = state.blobFile || {};
      const blobFile = { id, blobUrl, file };
      return { ...state, blobFile, blobFileUploadInProgress: false };
    }
    case BLOB_FILE_UPLOAD_IMAGE_ERROR: {
      return { ...state, blobFile: null, blobFileUploadInProgress: false, blobFileUploadError: payload.error };
    }

    case CREATE_CREDENTIALS_REQUEST:
      return { ...state, createCredentialsError: null, submitInProgress: true };
    case CREATE_CREDENTIALS_SUCCESS:
      return { ...state, submitInProgress: false };
    case CREATE_CREDENTIALS_ERROR:
      return { ...state, createCredentialsError: payload, submitInProgress: false };
    
    case GET_CREDENTIALS_REQUEST:
      return { ...state, getCredentialsError: null, fetchingCredentials: true};
    case GET_CREDENTIALS_SUCCESS:
      return {
        ...state,
        fetchingCredentials: false,
        credentials: payload?.credentials || [],
        credentialsFetched: payload?.credentialsFetched || 0,
        failedCredentials: withTrustStates(payload?.failed)
      };
    case GET_CREDENTIALS_ERROR:
      return { ...state, getCredentialsError: payload, fetchingCredentials: false };

    case UPDATE_USER_DID_REQUEST:
      return { ...state, updateUserDIDInProgress: true, updateUserDIDError: null };
    case UPDATE_USER_DID_SUCCESS:
      return { ...state, updateUserDIDInProgress: false };
    case UPDATE_USER_DID_ERROR:
      return { ...state, updateUserDIDInProgress: false, updateUserDIDError: payload };

    case FETCH_PROFILE_LISTING_REQUEST:
      return { ...state, fetchProfileListingInProgress: true, fetchProfileListingError: null };
    case FETCH_PROFILE_LISTING_SUCCESS:
      return { ...state, fetchProfileListingInProgress: false, profileListing: payload };
    case FETCH_PROFILE_LISTING_ERROR:
      return { ...state, fetchProfileListingInProgress: false, fetchProfileListingError: payload };

    case UPDATE_LISTING_REQUEST:
      return { ...state, updateListingInProgress: true, updateListingError: null };
    case UPDATE_LISTING_SUCCESS:
      return { ...state, updateListingInProgress: false, profileListing: payload };
    case UPDATE_LISTING_ERROR:
      return { ...state, updateListingInProgress: false, updateListingError: payload };

    case SAVE_PAYMENT_SESSION_ID_REQUEST:
      return { ...state, savingPayment: true, savingPaymentSuccess: false, savingPaymentError: null };
    case SAVE_PAYMENT_SESSION_ID_SUCCESS:
      return { ...state, savingPayment: false, savingPaymentSuccess: true, savingPaymentError: null };
    case SAVE_PAYMENT_SESSION_ID_ERROR:
      return { ...state, savingPayment: false, savingPaymentSuccess: false, savingPaymentError: payload };

    case REVOKE_CREDENTIAL_REQUEST:
      return { ...state, revokeCredentialInProgress: true, revokeCredentialError: null };
    case REVOKE_CREDENTIAL_SUCCESS:
      return { ...state, revokeCredentialInProgress: false };
    case REVOKE_CREDENTIAL_ERROR:
      return { ...state, revokeCredentialInProgress: false, revokeCredentialError: payload };

    case SAVE_CONSENT_REQUEST:
      return { ...state, savingConsent: true, savingConsentSuccess: false, savingConsentError: null };
    case SAVE_CONSENT_SUCCESS:
      return { ...state, savingConsent: false, savingConsentSuccess: true, savingConsentError: null };
    case SAVE_CONSENT_ERROR:
      return { ...state, savingConsent: false, savingConsentSuccess: false, savingConsentError: payload };

    case FETCH_CONSENT_REQUEST:
      return { ...state, fetchingConsent: true, fetchConsentError: null };
    case FETCH_CONSENT_SUCCESS:
      return { ...state, fetchingConsent: false, existingConsent: payload };
    case FETCH_CONSENT_ERROR:
      return { ...state, fetchingConsent: false, fetchConsentError: payload };

    case FETCH_VAULT_DOC_NAMES_REQUEST:
      return { ...state, fetchingVaultDocNames: true, fetchVaultDocNamesError: null };
    case FETCH_VAULT_DOC_NAMES_SUCCESS:
      return { ...state, fetchingVaultDocNames: false, vaultDocNames: payload };
    case FETCH_VAULT_DOC_NAMES_ERROR:
      return { ...state, fetchingVaultDocNames: false, fetchVaultDocNamesError: payload };

    case FETCH_VAULT_DOC_DETAILS_REQUEST:
      return { ...state, fetchingVaultDocDetails: true, vaultDocDetails: null, fetchVaultDocDetailsError: null, vaultDocDetailsTrust: null };
    case FETCH_VAULT_DOC_DETAILS_SUCCESS:
      return { ...state, fetchingVaultDocDetails: false, vaultDocDetails: payload };
    case FETCH_VAULT_DOC_DETAILS_ERROR:
      return { ...state, fetchingVaultDocDetails: false, fetchVaultDocDetailsError: payload };
    case FETCH_VAULT_DOC_DETAILS_UNTRUSTED:
      return { ...state, fetchingVaultDocDetails: false, vaultDocDetailsTrust: payload };

    case FETCH_CANDIDATE_INTEGRITY_STATUS_REQUEST:
      return { ...state, fetchingCandidateIntegrityStatus: true, fetchCandidateIntegrityStatusError: null };
    case FETCH_CANDIDATE_INTEGRITY_STATUS_SUCCESS:
      return {
        ...state,
        fetchingCandidateIntegrityStatus: false,
        candidateHasIntegrityCheck: payload.hasIntegrityCheck,
        candidateEadCategoryConfirmed: payload.eadCategoryConfirmed === true,
      };
    case FETCH_CANDIDATE_INTEGRITY_STATUS_ERROR:
      return { ...state, fetchingCandidateIntegrityStatus: false, fetchCandidateIntegrityStatusError: payload };

    case MARK_INTEGRITY_CHECK_VERIFICATION_COMPLETED:
      return { ...state, candidateHasIntegrityCheck: false };

    default:
      return state;
  }
}

// ================ Action creators ================ //

const fetchOrdersOrSalesRequest = () => ({ type: FETCH_ORDERS_OR_SALES_REQUEST });
const fetchOrdersOrSalesSuccess = response => ({
  type: FETCH_ORDERS_OR_SALES_SUCCESS,
  payload: response,
});
const fetchOrdersOrSalesError = e => ({
  type: FETCH_ORDERS_OR_SALES_ERROR,
  error: true,
  payload: e,
});

const createCheckoutSessionRequest = () => ({ type: CREATE_CHECKOUT_SESSION_REQUEST });
const createCheckoutSessionSuccess = response => ({
  type: CREATE_CHECKOUT_SESSION_SUCCESS,
  payload: response,
});
const createCheckoutSessionError = e => ({
  type: CREATE_CHECKOUT_SESSION_ERROR,
  error: true,
  payload: e,
});

export const updateOtherUserRequest = params => ({
  type: UPDATE_OTHER_USER_REQUEST,
  payload: { params },
});
export const updateOtherUserSuccess = result => ({
  type: UPDATE_OTHER_USER_SUCCESS,
  payload: result,
});
export const updateOtherUserError = error => ({
  type: UPDATE_OTHER_USER_ERROR,
  payload: error,
  error: true,
});

export const uploadBlobFileRequest = params => ({ type: BLOB_FILE_UPLOAD_IMAGE_REQUEST, payload: { params } });
export const uploadBlobFileSuccess = result => ({ type: BLOB_FILE_UPLOAD_IMAGE_SUCCESS, payload: result.data });
export const uploadBlobFileError = error => ({
  type: BLOB_FILE_UPLOAD_IMAGE_ERROR,
  payload: error,
  error: true,
});

export const createCredentialsRequest = () => ({ type: CREATE_CREDENTIALS_REQUEST });
export const createCredentialsSuccess = () => ({ type: CREATE_CREDENTIALS_SUCCESS });
export const createCredentialsError = e => ({ type: CREATE_CREDENTIALS_ERROR, error: true, payload: e });

export const getCredentialsRequest = () => ({ type: GET_CREDENTIALS_REQUEST });
export const getCredentialsSuccess = (payload) => ({ type: GET_CREDENTIALS_SUCCESS, payload });
export const getCredentialsError = e => ({ type: GET_CREDENTIALS_ERROR, error: true, payload: e });

export const updateUserDIDRequest = () => ({ type: UPDATE_USER_DID_REQUEST });
export const updateUserDIDSuccess = () => ({ type: UPDATE_USER_DID_SUCCESS });
export const updateUserDIDError = e => ({ type: UPDATE_USER_DID_ERROR, error: true, payload: e });

export const fetchProfileListingRequest = () => ({ type: FETCH_PROFILE_LISTING_REQUEST });
export const fetchProfileListingSuccess = listing => ({ type: FETCH_PROFILE_LISTING_SUCCESS, payload: listing });
export const fetchProfileListingError = e => ({ type: FETCH_PROFILE_LISTING_ERROR, error: true, payload: e });

export const updateListingRequest = () => ({ type: UPDATE_LISTING_REQUEST });
export const updateListingSuccess = listing => ({ type: UPDATE_LISTING_SUCCESS, payload: listing });
export const updateListingError = e => ({ type: UPDATE_LISTING_ERROR, error: true, payload: e });

export const savingPaymentRequest = () => ({ type: SAVE_PAYMENT_SESSION_ID_REQUEST });
export const savingPaymentSuccess = () => ({ type: SAVE_PAYMENT_SESSION_ID_SUCCESS });
export const savingPaymentError = () => ({ type: SAVE_PAYMENT_SESSION_ID_ERROR });

export const revokeCredentialRequest = () => ({ type: REVOKE_CREDENTIAL_REQUEST });
export const revokeCredentialSuccess = () => ({ type: REVOKE_CREDENTIAL_SUCCESS });
export const revokeCredentialError = e => ({ type: REVOKE_CREDENTIAL_ERROR, error: true, payload: e });

const saveConsentRequest = () => ({ type: SAVE_CONSENT_REQUEST });
const saveConsentSuccess = () => ({ type: SAVE_CONSENT_SUCCESS });
const saveConsentError = e => ({ type: SAVE_CONSENT_ERROR, error: true, payload: e });

const fetchConsentRequest = () => ({ type: FETCH_CONSENT_REQUEST });
const fetchConsentSuccess = payload => ({ type: FETCH_CONSENT_SUCCESS, payload });
const fetchConsentError = e => ({ type: FETCH_CONSENT_ERROR, error: true, payload: e });

const fetchVaultDocNamesRequest = () => ({ type: FETCH_VAULT_DOC_NAMES_REQUEST });
const fetchVaultDocNamesSuccess = payload => ({ type: FETCH_VAULT_DOC_NAMES_SUCCESS, payload });
const fetchVaultDocNamesError = e => ({ type: FETCH_VAULT_DOC_NAMES_ERROR, error: true, payload: e });

const fetchVaultDocDetailsRequest = () => ({ type: FETCH_VAULT_DOC_DETAILS_REQUEST });
const fetchVaultDocDetailsSuccess = payload => ({ type: FETCH_VAULT_DOC_DETAILS_SUCCESS, payload });
const fetchVaultDocDetailsError = e => ({ type: FETCH_VAULT_DOC_DETAILS_ERROR, error: true, payload: e });
const fetchVaultDocDetailsUntrusted = trustState => ({ type: FETCH_VAULT_DOC_DETAILS_UNTRUSTED, payload: trustState });

const fetchCandidateIntegrityStatusRequest = () => ({ type: FETCH_CANDIDATE_INTEGRITY_STATUS_REQUEST });
const fetchCandidateIntegrityStatusSuccess = payload => ({ type: FETCH_CANDIDATE_INTEGRITY_STATUS_SUCCESS, payload });
const fetchCandidateIntegrityStatusError = e => ({ type: FETCH_CANDIDATE_INTEGRITY_STATUS_ERROR, error: true, payload: e });


// ================ Thunks ================ //

const INBOX_PAGE_SIZE = 10;

const mergeByItemId = (existing, incoming) => {
    const map = new Map();

    // Add existing first
    existing.forEach(item => map.set(item.itemId, item));

    // Overwrite with incoming (replaces if same itemId)
    incoming.forEach(item => map.set(item.itemId, item));

    // Convert back to array
    return Array.from(map.values());
  };

const getMainAccountId = async (user, sdk) => {
  if (!user) return null;
  
  const userType = userTypeOf(user);
  const role = teamRoleOf(user);
  
  if (userType === 'agency' || userType === 'customer') {
    if (role === 'Admin' && user?.attributes?.profile?.publicData?.firstListingId !== undefined) {
      return user.id?.uuid;
    } else {
      const profileListingId = user.attributes?.profile?.publicData?.profileListingId;
      
      const listingResponse = await sdk.listings.show({ id: profileListingId });
      const listing = listingResponse?.data?.data;
      
      return listing?.attributes?.publicData?.adminId;
    }
  }
  
  return user.id?.uuid;
};

export const loadData = (params, search) => (dispatch, getState, sdk) => {
  const state = getState();
  const currentUser = state.user?.currentUser;

  // Get listing ID from currentUser profile
  const listingId = currentUser?.attributes?.profile?.publicData?.profileListingId ||
                    currentUser?.attributes?.profile?.publicData?.firstListingId;

  const promises = [];

  // Fetch profile listing if listingId exists
  if (listingId) {
    dispatch(fetchProfileListingRequest());

    const isCompany = ['agency', 'customer'].includes(userTypeOf(currentUser));
    const listingPromise = sdk.listings.show({ id: listingId })
      .then(async response => {
        // A company's owners and tax details are loaded separately and laid over its listing.
        const shared = isCompany
          ? (await loadCompanyCredentialDetails(response?.data?.data, listingId)).listing
          : response?.data?.data;
        const listing = await withOwnPrivateData(shared, listingId);
        dispatch(fetchProfileListingSuccess(listing));
        dispatch(addMarketplaceEntities(response));
        return listing;
      })
      .catch(e => {
        dispatch(fetchProfileListingError(storableError(e)));
        throw e;
      });

    promises.push(listingPromise);

    // Fetch user persona records in parallel
    const personaPromise = dispatch(fetchUserPersonaRecords(listingId));
    promises.push(personaPromise);

    // Whether the verification consent was already given: every verification opened from the
    // Wallet needs it, a company's own check as much as a candidate's.
    const userType = userTypeOf(currentUser);
    if (userType === 'candidate' || userType === 'agency' || userType === 'customer') {
      const consentPromise = dispatch(fetchConsentAction({
        consentType: 'Verification',
        candidateListingId: listingId,
      }));
      promises.push(consentPromise);
    }

    // For candidates, the integrity check status
    if (userType === 'candidate') {
      const integrityStatusPromise = dispatch(fetchCandidateIntegrityStatusAction());
      promises.push(integrityStatusPromise);
    }

    // Fetch vault doc names for all user types (candidate, agency, customer)
    if (userType === 'candidate' || userType === 'agency' || userType === 'customer') {
      const vaultPromise = dispatch(fetchVaultDocNames());
      promises.push(vaultPromise);
    }
  }

  return Promise.all(promises)
    .then(response => {
      return response;
    })
    .catch(e => {
      dispatch(fetchOrdersOrSalesError(storableError(e)));
      throw e;
    });
};

/**
 * Starts a Stripe checkout. A Wallet verification purchase passes `walletPurchase`
 * ({ documentIds, scope }): the server then works out who pays and what each document costs, so
 * only the purchase itself is sent. Any other checkout names the consent saved for it in
 * `consentId`, when one was.
 */
export const createCheckoutSessionDuck = (priceId, quantity, type, walletPurchase = null, consentId = null) => async (dispatch, getState, sdk) => {
  dispatch(createCheckoutSessionRequest());

  if (walletPurchase) {
    return createCheckoutSession({
      isWalletVerification: true,
      priceId,
      documentIds: walletPurchase.documentIds,
      scope: walletPurchase.scope,
    })
      .then(response => {
        dispatch(createCheckoutSessionSuccess(response));
        return response;
      })
      .catch(e => {
        dispatch(createCheckoutSessionError(storableError(e)));
        throw e;
      });
  }
 
  const state = getState();
  const currentUser = state.user?.currentUser;
  const profileListing = state.user?.profileListing;
  
  const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId ||
                    currentUser?.attributes?.profile?.publicData?.firstListingId;

  let email = null;
  let adminId = '';

  if (!profileListingId) {
    return;
  }

  if (userTypeOf(currentUser) === 'candidate') {
    adminId = currentUser?.id?.uuid;
    email = currentUser?.attributes?.email;
  } else {
    // let profileListing = await sdk.listings.show({ id: profileListingId });
    // profileListing = profileListing?.data?.data;

    email = currentUser?.attributes?.email;

    adminId = profileListing?.attributes?.publicData?.adminId;
    // if (adminId) {
    //   const adminUserResponse = await getUserDetails({ userId: adminId });
    //   const adminUser = adminUserResponse?.data?.data;
    //   email = adminUser?.attributes?.email;
    // }
  }

  if (!email) {
    console.error("Email not found for checkout session.");
    return;
  }

  return createCheckoutSession({ priceId, quantity, type, email, paidBy: adminId, ...(consentId ? { consentId } : {}) })
    .then(async response => {
      
      dispatch(createCheckoutSessionSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(createCheckoutSessionError(storableError(e)));
      throw e;
    });
}

export const updateOtherUser = (actionPayload = {}) => async (dispatch, getState, sdk) => {
  dispatch(updateOtherUserRequest());

  const state = getState();
  const currentUser = state.user?.currentUser;

  const isMainUser = currentUser?.attributes?.profile?.publicData?.firstListingId ? true : false;

  let selectedWalletDocs = [];

  // The person's earlier picks are read private-first: older profiles may still hold them in
  // public data until they are moved.
  const profile = currentUser?.attributes?.profile;
  let currentSelectedItems = walletRecordOf(profile, 'selectedItemsCheckout') || [];
  let currentSelectedWalletDocs = walletRecordOf(profile, 'selectedWalletDocs') || [];

  const { toSendEducationVerification, toSendExperienceVerification } = actionPayload;

  let currentToSendEducationVerification = walletRecordOf(profile, 'educationVerification') || [];

  let currentToSendExperienceVerification = walletRecordOf(profile, 'experienceVerification') || [];

  // Merge Education
  if (Array.isArray(toSendEducationVerification) && toSendEducationVerification.length > 0) {
    currentToSendEducationVerification = mergeByItemId(
      currentToSendEducationVerification,
      toSendEducationVerification
    );
  }

  // Merge Experience
  if (Array.isArray(toSendExperienceVerification) && toSendExperienceVerification.length > 0) {
    currentToSendExperienceVerification = mergeByItemId(
      currentToSendExperienceVerification,
      toSendExperienceVerification
    );
  }

  // The documents bought for verification are recorded by the server from the payment itself; the
  // stored list is only carried through unchanged.
  if(typeof localStorage !== 'undefined') {
    selectedWalletDocs = localStorage.getItem('selectedWalletDocs');
    selectedWalletDocs = selectedWalletDocs ? JSON.parse(selectedWalletDocs) : [];

    currentSelectedWalletDocs = [...currentSelectedWalletDocs, ...selectedWalletDocs];

    localStorage.removeItem('selectedWalletDocs');
    localStorage.removeItem('selectedItems');
  }

  if (isMainUser) {
    try {
      // The picks are the person's own, so they are saved to private data and removed from public
      // data, where older profiles may still hold them.
      const { publicData, privateData } = separateWalletRecords({
        publicData: {
          selectedItemsCheckout: currentSelectedItems,
          selectedWalletDocs: currentSelectedWalletDocs,
          educationVerification: currentToSendEducationVerification,
          experienceVerification: currentToSendExperienceVerification,
          // educationUploads: currentEducationUploads,
          // experienceUploads: currentExperienceUploads,
        },
      });
      return sdk.currentUser.updateProfile({ publicData, privateData }).then(async res => {
          await updateOtherUsers({
            userId: currentUser?.id?.uuid,
            updateWalletMainUser: true,
            selectedItemsCheckout: currentSelectedItems,
            selectedWalletDocs: currentSelectedWalletDocs,
            educationVerification: currentToSendEducationVerification,
            experienceVerification: currentToSendExperienceVerification,
          });

          dispatch(updateOtherUserSuccess(res));
          dispatch(fetchCurrentUser());
          return res;
          })
        .catch(e => {
          dispatch(updateOtherUserError(storableError(e)))
        });
    } catch (error) {
      console.error("Error updating user profile:", error);
    }
  } else {
    try {
      let adminId = await getMainAccountId(currentUser, sdk);

      if (!adminId) {
        console.error("Admin ID not found for the current user.");
        return;
      }

      return updateOtherUsers({
          adminId,
          selectedItemsCheckout: currentSelectedItems,
          selectedWalletDocs: currentSelectedWalletDocs,
          createCheckoutSession: true,
          educationVerification: currentToSendEducationVerification,
          experienceVerification: currentToSendExperienceVerification,
          // educationUploads: currentEducationUploads,
          // experienceUploads: currentExperienceUploads,
        }).then(res => {

          dispatch(updateOtherUserSuccess(res));
          return res;
        }).catch(e => {
          dispatch(updateOtherUserError(storableError(e)))
        });
    } catch (error) {
      console.error("Error updating other users:", error);
    }
  }
};

export function uploadBlobFile(actionPayload) {
  return (dispatch, getState, sdk) => {   
    const id = actionPayload.id;
    const formData = new FormData();

    formData.append('file', actionPayload.file);    
    dispatch(uploadBlobFileRequest(actionPayload));

    return uploadFileToBlob(formData)
    .then(res => {
        const blobUrl = res?.blobUrl;
        dispatch(uploadBlobFileSuccess({ data: { id, blobUrl } }));
        return res;
    })
    .catch(e => {

      dispatch(uploadBlobFileError({ id, error: storableError(e) }))});
  };
}

export const createCredentials = data => (dispatch, getState, sdk) => {
  dispatch(createCredentialsRequest());

  const state = getState();
  const currentUser = state.user?.currentUser;
  const profileListing = state.WalletPage?.profileListing;  // ✅ Get profileListing from state
  const existingWalletDID = currentUser?.attributes?.profile?.publicData?.walletDID;

  // Only update walletDID if it's provided and different from the existing one
  if(data?.userDid && existingWalletDID !== data?.userDid) {
    dispatch(updateUserDID(data?.userDid));
  }

  return dockCreateCredentials({
    email: currentUser?.attributes?.email,
    // Removed personaDocumentResponse - now fetched from user's stored inquiry IDs
    isSharing: true,
    userDid: data?.userDid || false,
    // ✅ NEW: Pass profileListing for proper field verification
    profileListing: profileListing,
    currentUser: currentUser
  })
    .then(res => {
      dispatch(createCredentialsSuccess());
      dispatch(loadData());
    })
    .catch(e => {
      dispatch(createCredentialsError(storableError(e)));
    });
};

export const getCredentials = (data) => (dispatch, getState, sdk) => {
  dispatch(getCredentialsRequest());
  const state = getState();
  const { currentUser } = state.user;

  const dockCredentials = currentUser?.attributes?.profile?.privateData?.dockIoCredentials || [];

  // Handle backward compatibility - if dockCredentials is an object, convert to array
  const credentialsArray = Array.isArray(dockCredentials) ? dockCredentials : [dockCredentials];

  return dockGetCredentials({
    credentials: credentialsArray,
  })
    .then(res => {
      dispatch(getCredentialsSuccess(res.data));
    })
    .catch(e => {
      // Credentials withheld for a re-check, or no longer verified, are still listed with their
      // state, even when nothing else could be fetched.
      const withheld = e?.status === 404 ? e?.data?.failed : null;
      if (Array.isArray(withheld) && withheld.length > 0) {
        dispatch(getCredentialsSuccess({ credentials: [], credentialsFetched: 0, failed: withheld }));
        return;
      }
      dispatch(getCredentialsError(storableError(e)));
    });
};

export const updateUserDID = (walletDID) => (dispatch, getState, sdk) => {
  dispatch(updateUserDIDRequest());

  const state = getState();
  const { currentUser } = state.user;

  return sdk.currentUser.updateProfile({
    publicData: {
      walletDID,
    },
  })
    .then(async res => {
      await updateOtherUsers({ userId: currentUser?.id?.uuid, updateWalletDID: true, walletDID:walletDID });

      dispatch(updateUserDIDSuccess());
      dispatch(fetchCurrentUser());
      return res;
    })
    .catch(e => {
      dispatch(updateUserDIDError(storableError(e)));
      throw e;
    });
};

export const updateListing = (updateParams = {}) => (dispatch, getState, sdk) => {
  dispatch(updateListingRequest());

  const state = getState();
  const currentUser = state.user?.currentUser;

  // Get listing ID from currentUser (same as loadData)
  const listingId = currentUser?.attributes?.profile?.publicData?.profileListingId ||
                    currentUser?.attributes?.profile?.publicData?.firstListingId;

  if (!listingId) {
    const error = new Error('No listing ID found for update');
    dispatch(updateListingError(storableError(error)));
    return Promise.reject(error);
  }

  // First, fetch the latest listing data
  return sdk.listings.show({ id: listingId })
    .then(async listingResponse => {
      // The earlier picks are in the listing's private data, which the public read does not return.
      const fetchedListing = await withOwnPrivateData(listingResponse?.data?.data, listingId);
      const attributes = fetchedListing?.attributes;

      // Get current data from the fetched listing
      let currentSelectedItems = walletRecordOf(attributes, 'selectedItemsCheckout') || [];
      let currentSelectedWalletDocs = walletRecordOf(attributes, 'selectedWalletDocs') || [];

      const { toSendEducationVerification, toSendExperienceVerification } = updateParams;

      let currentToSendEducationVerification = walletRecordOf(attributes, 'educationVerification') || [];

      let currentToSendExperienceVerification = walletRecordOf(attributes, 'experienceVerification') || [];

      // Merge Education
      if (Array.isArray(toSendEducationVerification) && toSendEducationVerification.length > 0) {
        currentToSendEducationVerification = mergeByItemId(
          currentToSendEducationVerification,
          toSendEducationVerification
        );
      }

      // Merge Experience
      if (Array.isArray(toSendExperienceVerification) && toSendExperienceVerification.length > 0) {
        currentToSendExperienceVerification = mergeByItemId(
          currentToSendExperienceVerification,
          toSendExperienceVerification
        );
      }

      // Merge localStorage data. The documents bought for verification are recorded by the server
      // from the payment itself; the stored list is only carried through unchanged.
      if (typeof localStorage !== 'undefined') {
        let selectedWalletDocs = localStorage.getItem('selectedWalletDocs');
        selectedWalletDocs = selectedWalletDocs ? JSON.parse(selectedWalletDocs) : [];

        currentSelectedWalletDocs = [...currentSelectedWalletDocs, ...selectedWalletDocs];

        localStorage.removeItem('selectedWalletDocs');
        localStorage.removeItem('selectedItems');
      }

      // Now update the listing with merged data using createNewListing API
      return createNewListing({
        listingId: listingId,
        selectedItemsCheckout: currentSelectedItems,
        selectedWalletDocs: currentSelectedWalletDocs,
        educationVerification: currentToSendEducationVerification,
        experienceVerification: currentToSendExperienceVerification,
        saveWalletDetails: true,
      });
    })
    .then(response => {
      const updatedListing = response?.data?.data;
      dispatch(updateListingSuccess(updatedListing));
      return updatedListing;
    })
    .catch(e => {
      dispatch(updateListingError(storableError(e)));
      throw e;
    });
};

// Loads what each Wallet document needs before it can be verified, for the caller's own documents
// ('self') or their company's ('company').
export const fetchWalletDocumentStates = ({ scope }) => (dispatch, getState, sdk) => {
  dispatch({ type: FETCH_WALLET_DOCUMENT_STATES_REQUEST });
  return fetchWalletDocumentStatesApi({ scope })
    .then(response => {
      const states = response?.states && typeof response.states === 'object' ? response.states : {};
      const ownerVerifications = Array.isArray(response?.ownerVerifications) ? response.ownerVerifications : [];
      dispatch({ type: FETCH_WALLET_DOCUMENT_STATES_SUCCESS, payload: states, ownerVerifications });
      return states;
    })
    .catch(e => {
      dispatch({ type: FETCH_WALLET_DOCUMENT_STATES_ERROR, payload: storableError(e), error: true });
      return null;
    });
};

export const savePaymentSessionId = (sessionId) => async (dispatch, getState, sdk) => {
  dispatch(savingPaymentRequest());

  const state = getState();
  const currentUser = state.user?.currentUser;
  const profileListing = state.user?.profileListing;

  const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId ||
                    currentUser?.attributes?.profile?.publicData?.firstListingId;

  let email = null;
  let adminId = '';

  if (!profileListingId) {
    return;
  }

  if (userTypeOf(currentUser) === 'candidate') {
    adminId = currentUser?.id?.uuid;
    email = currentUser?.attributes?.email;
  } else {
    adminId = profileListing?.attributes?.publicData?.adminId;
    email = currentUser?.attributes?.email;
  }

  if (!email) {
    console.error("Email not found for checkout session.");
    return;
  }

  return saveWalletPagePayments({ sessionId: sessionId, userId: adminId, profileListingId: profileListingId, actionType: 'create' })
    .then(response => {
      dispatch(savingPaymentSuccess(response));
      return true;
    })
    .catch(err => {
      dispatch(savingPaymentError(err));
      return false;
    });
};

export const saveConsentAction = (consentData) => (dispatch, getState) => {
  dispatch(saveConsentRequest());

  return saveConsent(consentData)
    .then(response => {
      dispatch(saveConsentSuccess());
      // Also update existingConsent so UI reflects the saved state
      dispatch(fetchConsentSuccess({
        hasConsent: true,
        consent: {
          consentId: response?.consentId,
          consentType: consentData.consentType,
          timestamp: new Date().toISOString(),
        },
      }));
      return response;
    })
    .catch(e => {
      dispatch(saveConsentError(storableError(e)));
      throw e;
    });
};

export const fetchConsentAction = (consentData) => (dispatch) => {
  dispatch(fetchConsentRequest());

  return saveConsent({ ...consentData, actionType: 'fetch' })
    .then(response => {
      dispatch(fetchConsentSuccess(response || { hasConsent: false, consent: null }));
      return response;
    })
    .catch(e => {
      dispatch(fetchConsentError(storableError(e)));
    });
};

export const revokeCredential = (credentialData) => (dispatch, getState, sdk) => {
  dispatch(revokeCredentialRequest());

  const state = getState();
  const currentUser = state.user?.currentUser;

  // Get listing ID from currentUser
  const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId ||
                    currentUser?.attributes?.profile?.publicData?.firstListingId;

  if (!profileListingId) {
    const error = new Error('No listing ID found');
    dispatch(revokeCredentialError(storableError(error)));
    return Promise.reject(error);
  }

  const { credential, documentName } = credentialData;

  return dockRevokeCredential({
    credential,
    documentName,
    profileListingId,
  })
    .then(response => {
      dispatch(revokeCredentialSuccess());
      // Reload the data to reflect the updated status
      dispatch(loadData());
      dispatch(fetchUserPersonaRecords(profileListingId));
      return response;
    })
    .catch(e => {
      dispatch(revokeCredentialError(storableError(e)));
      throw e;
    });
};

export const fetchVaultDocNames = () => (dispatch, getState) => {
  dispatch(fetchVaultDocNamesRequest());

  const state = getState();
  const currentUser = state.user?.currentUser;
  const profileListingId = currentUser?.attributes?.profile?.publicData?.profileListingId ||
    currentUser?.attributes?.profile?.publicData?.firstListingId;

  return getCredentialVaultDocNames({ profileListingId })
    .then(async response => {
      // RSA decrypt if the response is encrypted
      const data = response?.rsaEncrypted
        ? await rsaHybridDecrypt(response.data)
        : response?.data || [];
      dispatch(fetchVaultDocNamesSuccess(data));
      return response;
    })
    .catch(e => {
      console.error('[WalletPage] fetchVaultDocNames error:', e);
      dispatch(fetchVaultDocNamesError(storableError(e)));
    });
};

// Shares one screening credential by its exact key, so the share can only ever resolve to that
// credential, with the four fields a screening credential holds. A refused share (for example an
// expired credential) is passed back to the caller. `consentId` names the share consent the sharer
// saved for this share; the server refuses a share without one. The share carries a submission key,
// so a retry after a lost answer is recognised as the same share and the recipient is emailed once.
// The consent is kept out of the payload the key is matched on, so a retry with a freshly saved
// consent is still the same share.
export const shareScreeningCredential = ({
  profileListingId,
  docKey,
  recipientName,
  recipientEmail,
  consentId,
}) => () =>
  keyedSubmission(
    'screening-share',
    {
      profileListingId,
      documentType: docKey,
      vaultDocumentKey: docKey,
      requestedFields: [...SCREENING_SHARED_FIELDS],
      recipientName,
      recipientEmail,
      deliveryPreference: { byEmail: true, bySMS: false },
    },
    body => shareCredential({ ...body, ...(consentId ? { consentId } : {}) })
  );

export const fetchCandidateIntegrityStatusAction = () => (dispatch) => {
  dispatch(fetchCandidateIntegrityStatusRequest());
  return fetchCandidateIntegrityStatusApi()
    .then(response => {
      dispatch(fetchCandidateIntegrityStatusSuccess(response));
      return response;
    })
    .catch(e => {
      dispatch(fetchCandidateIntegrityStatusError(storableError(e)));
    });
};

// Resolves to the server's answer, so the page can say why a check was not completed. The check is
// closed only when the server marked it completed; a refusal ({ updated: false, ... }) keeps it open.
export const markIntegrityCheckCompletedAction = () => (dispatch) => {
  return markIntegrityCheckVerificationCompletedApi()
    .then(answer => {
      if (answer?.updated !== false) {
        dispatch({ type: MARK_INTEGRITY_CHECK_VERIFICATION_COMPLETED });
      }
      return answer;
    })
    .catch(e => {
      console.error('Failed to mark integrity check verification as completed:', e);
      return null;
    });
};

export const fetchVaultDocDetails = (documentType) => (dispatch) => {
  dispatch(fetchVaultDocDetailsRequest());

  return getPersonaFieldValues({ documentType })
    .then(async response => {
      // RSA decrypt if the response is encrypted
      const decrypted = response?.rsaEncrypted
        ? await rsaHybridDecrypt(response.data)
        : response?.data || null;

      // Verify Ed25519 signature on the decrypted credential data. The server signs every document
      // it returns, so a document without a signature is treated like one that failed the check.
      if (decrypted) {
        const { data, signatureValid } = decrypted.ed25519Signature
          ? await verifyAndExtractSignature(decrypted)
          : { data: decrypted, signatureValid: null };
        if (signatureValid !== true) {
          // Details we could not confirm are never shown; the failure is reported for follow-up.
          console.error('[WalletPage] Ed25519 signature verification failed for documentType:', documentType);
          reportCredentialCheckFailed({
            credentialId: decrypted.credentialId,
            documentType,
            surface: 'wallet',
          });
          dispatch(fetchVaultDocDetailsUntrusted(CREDENTIAL_CHECK_FAILED));
          return response;
        }
        dispatch(fetchVaultDocDetailsSuccess(data));
      } else {
        dispatch(fetchVaultDocDetailsSuccess(decrypted));
      }
      return response;
    })
    .catch(e => {
      const trustState = credentialTrustStateOf(e);
      if (trustState) {
        dispatch(fetchVaultDocDetailsUntrusted(trustState));
        return;
      }
      dispatch(fetchVaultDocDetailsError(storableError(e)));
    });
};

